export enum EntityStoreKey {
  hiddenEvaluations = 'hiddenEvaluations',
}
